<template>
  <div class="jcdet">
    <div class="jcdetc">
      <div class="tit">{{content.decisionName}}</div>
      <div class="con" v-html="content.content">
      </div>
      <div class="info" >
        <div>开始时间：{{content.dateStart.substr(0,11)}}</div>
		<div>结束时间：{{content.dateEnd.substr(0,11)}}</div>
        <div>决策分类：{{content.decisionCategory}}</div>
        <div v-if="content.status == '未开始'">状态：未开始</div>
        <div v-else-if="content.status == '进行中'">状态：<span style="color: #26cb26">进行中</span></div>
        <div v-else>状态：<span style="color: #d00e0e">已结束</span></div>
      </div>
      <div class="selDv" v-if="content.status == '进行中'&&!content.isAnswer&&(userType==1||userType==2)" >
        <div class="lit-tit">决策投票</div>
        <van-radio-group v-model="choose" direction="horizontal">
          <van-radio name="1" shape="square" icon-size="28px">赞成</van-radio>
          <van-radio name="2" shape="square" icon-size="28px">反对</van-radio>
          <van-radio name="3" shape="square" icon-size="28px">弃权</van-radio>
        </van-radio-group>
        <div class="btn" @click="handleTou()">提交</div>
      </div>
	  <div class="selDv" v-if="content.isAnswer" >
	    <div class="lit-tit">您投给了：
			<span v-if="content.choose=='1'">赞成</span>
			<span v-else-if="content.choose=='2'">反对</span>
			<span v-else-if="content.choose=='3'">弃权</span>
		</div>
	  </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { RadioGroup, Radio,Toast } from "vant";
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Toast);
export default {
  data() {
    return {
        userType:'',
        id:'',
        choose: "",
        content:{
            dateStart:'',
            dateEnd:''
        }
    };
  },
  mounted() {
    this.userType = sessionStorage.getItem('currentHouseUserType')
    console.log("🚀 ~ file: jcdet.vue:54 ~ mounted ~ this.userType:", this.userType)
    this.id = this.$route.query.id;
	this.$axios.get('/api/v1/wechat/yzjc/'+this.id).then(res => {
		this.content=res;
	});
  },
  methods: {
    handleTou(){
	 this.$axios({
		url: '/api/v1/wechat/yzjc/feedback',
		method: 'post',
		headers: {
			'content-type': 'application/x-www-form-urlencoded'
		},
		data: this.qs.stringify({
			id: this.id,
			choose:this.choose
		}),
	 }).then(res => {
		 this.$set(this.content,'isAnswer',true);
		 this.$set(this.content,'choose',this.choose)
		 Toast.success('投票成功');
	 });
    }
  },
};
</script>
<style lang="less" >
.jcdet {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .jcdetc {
	  margin:0 15px 15px;
	  padding-top: 10px;
    .tit {
      font-size: 18px;
      color: #515151;
	  margin-bottom: 10px;
	  text-align: center;
    }
    .tim {
      font-size: 13px;
      color: #a2a2a2;
      margin: 10px auto;
      margin-top: -10px;
    }
    .con {
      width: 100%;
      line-height: 30px;
      box-shadow: 0px 0px 2px 0px rgba(84, 84, 84, 0.43);
      border-radius: 7px;
      padding: 15px 20px;
      margin: 10px auto;
      .jiao {
        text-indent:0;
        color: #a2a2a2;
        font-size: 13px;
        margin-left: 50%;
      }
    }
    .info {
      margin: 10px 0;
      div {
        margin-bottom: 10px;
      }
    }
    .selDv {
      width: 100%;
      border-top: 1px solid lightgray;
      .lit-tit {
        font-size: 15px;
        color: #00b5ff;
        margin: 10px auto;
      }
      .van-radio-group {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin: 30px auto;
      }
      .btn {
        width: 90%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #00b5ff;
        border-radius: 5px;
        margin: 0 auto;
        margin-top: 20px;
        color: #ffffff;
        font-size: 16px;
      }
    }
  }
}
</style>